import { MedicalAssistance } from ".";

export default function MedicalAssistanceExamples() {
  return <MedicalAssistance showInformationPrompt={true} />;
}
